/**
 * WireScript Schema v2 - Type Definitions
 *
 * Core types for AST nodes and values.
 */
// =============================================================================
// Type Guards
// =============================================================================
export function isParamRef(value) {
    return typeof value === 'object' && value !== null && value.type === 'param';
}
export function isScreenRef(value) {
    return typeof value === 'object' && value !== null && value.type === 'screen';
}
export function isOverlayRef(value) {
    return typeof value === 'object' && value !== null && value.type === 'overlay';
}
export function isActionRef(value) {
    return typeof value === 'object' && value !== null && value.type === 'action';
}
export function isUrlRef(value) {
    return typeof value === 'object' && value !== null && value.type === 'url';
}
export function isRef(value) {
    return typeof value === 'object' && value !== null && 'type' in value;
}
export function isLiteral(value) {
    return typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number';
}
export const VIEWPORTS = ['mobile', 'tablet', 'desktop'];
export const VIEWPORTS_SET = new Set(VIEWPORTS);
export const OVERLAY_TYPES = ['modal', 'drawer', 'popover'];
export const OVERLAY_TYPES_SET = new Set(OVERLAY_TYPES);
export const ACTION_KEYWORDS = ['close', 'back', 'submit'];
export const ACTION_KEYWORDS_SET = new Set(ACTION_KEYWORDS);
export const TOP_LEVEL_FORMS = ['screen', 'define', 'layout'];
export const TOP_LEVEL_FORMS_SET = new Set(TOP_LEVEL_FORMS);
/** Special structural constructs (not in ELEMENTS registry but are containers) */
export const STRUCTURAL_CONTAINERS = [
    'wire',
    'screen',
    'define',
    'layout',
    'modal',
    'drawer',
    'popover',
    'repeat',
    'meta',
];
export const STRUCTURAL_CONTAINERS_SET = new Set(STRUCTURAL_CONTAINERS);
/** Valid element types */
export const ELEMENT_TYPES = [
    // Containers
    'box',
    'card',
    'section',
    'header',
    'footer',
    'nav',
    'form',
    'list',
    'scroll',
    'group',
    // Content
    'text',
    'icon',
    'image',
    'avatar',
    'badge',
    'divider',
    // Interactive
    'button',
    'dropdown',
    // Inputs
    'input',
    'datepicker',
    // Data
    'metric',
    'progress',
    'chart',
    'skeleton',
    // Navigation
    'tabs',
    'tab',
    'breadcrumb',
    'crumb',
    // Utility
    'tooltip',
    'toast',
    'empty',
    'slot',
];
export const ELEMENT_TYPES_SET = new Set(ELEMENT_TYPES);
/** Valid flags/props that can be applied to elements */
export const VALID_FLAGS = [
    // Layout
    'row',
    'col',
    'grid',
    'wrap',
    // Alignment
    'start',
    'center',
    'end',
    'between',
    'around',
    'stretch',
    // Emphasis
    'high',
    'medium',
    'low',
    // Variant
    'primary',
    'secondary',
    'ghost',
    'danger',
    'success',
    'warning',
    'info',
    // State
    'disabled',
    'loading',
    'active',
    'checked',
    'open',
    'error',
    // Size
    'full',
    'fit',
    'fill',
    // Position
    'sticky',
    'fixed',
    'absolute',
    'relative',
    'top',
    'bottom',
    'left',
    'right',
    // Viewport
    'mobile',
    'tablet',
    'desktop',
    // Shape
    'circle',
    'text',
];
export const VALID_FLAGS_SET = new Set(VALID_FLAGS);
//# sourceMappingURL=types.js.map